import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class ConversationModel {
    static fromDTO(dto) {
        return new ConversationModel(dto.conversationId, dto.draftId, dto.turn, [
            ...dto.messages
        ]);
    }
    isTurnInFlight() {
        return this.turn != null;
    }
    constructor(conversationId, draftId, turn, messages){
        _define_property(this, "conversationId", void 0);
        _define_property(this, "draftId", void 0);
        _define_property(this, "turn", void 0);
        _define_property(this, "messages", void 0);
        this.conversationId = conversationId;
        this.draftId = draftId;
        this.turn = turn;
        this.messages = messages;
    }
}
